import SyncedProductsList from './SyncedProductsList'

export default SyncedProductsList
